import React from 'react';

import { EchoNavigate, EchoSlot, useEcho } from '@betterment/js-runtime';
import { Card, H2 } from '@betterment/samba-react';
import { useLoaderData } from 'react-router-dom';

import { ClientAgreementsSignatureHeader } from './ClientAgreementsSignatureHeader';

import { FullPageLoader } from '../FullPageLoader';
import { Layout } from '../InstitutionalApp/Layout';

export const ClientPackages: React.FC = () => {
  const { echo, onSubmit } = useEcho(useLoaderData());

  if (echo.type === 'navigation') {
    return <EchoNavigate echo={echo} fallback={<FullPageLoader />} />;
  }

  return (
    <Layout active="agreements">
      <Layout.Header>
        <ClientAgreementsSignatureHeader isLegacyAgreementsPage={false} />
      </Layout.Header>
      <Layout.Content>
        <Card>
          <Card.Header
            css={{
              display: 'flex',
              justifyContent: 'space-between',
              px: 'space.300',
              pt: 'space.300',
              pb: 'space.200',
            }}
          >
            <H2 variant="title200">Client packages</H2>
          </Card.Header>
          <Card.Content css={{ px: 'space.300', py: 'space.200' }}>
            <EchoSlot slot={echo.slots.main!} onSubmit={onSubmit} />
          </Card.Content>
        </Card>
      </Layout.Content>
    </Layout>
  );
};
